var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createContext, useCallback, useContext, useEffect, useMemo, useRef } from "react";
import { EventEmitter } from "nate-react-api-helpers";
import { useSyncedRef } from "../SyncedRef";
import { jsx as _jsx } from "react/jsx-runtime";
export const UndoContext = /*#__PURE__*/ createContext({ push: undo => { console.error("invalid undo context"); }, onCanUndo: new EventEmitter(), undo: () => { }, reset: () => { } });
export function UndoProvider(props) { const onCanUndo = useMemo(() => new EventEmitter(), []); const undoListRef = useRef([]); const inProgressRef = useRef(false); const undo = useCallback(() => __awaiter(this, void 0, void 0, function* () { if (inProgressRef.current)
    return; const last = undoListRef.current.pop(); if (undoListRef.current.length === 0) {
    onCanUndo.emit(false);
} if (!last) {
    return;
} inProgressRef.current = true; try {
    yield last();
}
catch (e) { } inProgressRef.current = false; }), [onCanUndo]); useEffect(() => { const undoKeyCommand = e => { if (e.key === "z" && (e.ctrlKey || e.metaKey)) {
    undo();
} }; document.body.addEventListener("keydown", undoKeyCommand); return () => { document.body.removeEventListener("keypress", undoKeyCommand); }; }, [undo]); const push = useCallback(input => { undoListRef.current.push(input); if (undoListRef.current.length === 1) {
    onCanUndo.emit(true);
} }, [onCanUndo, undoListRef]); const ctx = useMemo(() => ({ push: push, onCanUndo: onCanUndo, undo: undo, reset: () => { undoListRef.current = []; onCanUndo.emit(false); } }), [onCanUndo, undo, push]); return /*#__PURE__*/ _jsx(UndoContext.Provider, { value: ctx, children: props.children }); }
export function useUndoPush() {
    const ctx = useContext(UndoContext);
    const pushRef = useSyncedRef(ctx.push);
    const resetRef = useSyncedRef(ctx.reset);
    useEffect(() => {
        return () => resetRef.current();
    }, [resetRef]);
    return useCallback(input => { pushRef.current(input); }, [pushRef]);
}
export function useTypingUndo(props) {
    const lastValueRef = useRef(props.current);
    const lastTmRef = useRef(Date.now());
    const pushUndo = useUndoPush();
    const current = props.current;
    const currentRef = useSyncedRef(props.current);
    const ignore = props.ignore;
    const lastIgnoreRef = useRef(props.ignore);
    const onRestoreRef = useSyncedRef(props.onRestore);
    useEffect(() => {
        if (lastIgnoreRef.current) {
            lastValueRef.current = currentRef.current;
            lastTmRef.current = Date.now();
        }
        lastIgnoreRef.current = props.ignore;
    }, [props.ignore, currentRef]);
    useEffect(() => { if (props.ignore)
        return; if (lastValueRef.current === current)
        return; const delayMs = 800; const since = Date.now() - lastTmRef.current; const tm = setTimeout(() => { if (lastValueRef.current === current)
        return; const old = lastValueRef.current; lastValueRef.current = current; lastTmRef.current = Date.now(); pushUndo(() => onRestoreRef.current(old)); }, Math.max(delayMs - since, 0)); return () => clearTimeout(tm); }, [current, ignore, onRestoreRef, pushUndo, props.ignore]);
}
